// extracted by mini-css-extract-plugin
export default {"hint1":"Hints_hint1__xLbQ9","hint2":"Hints_hint2__7tRS6","hint3":"Hints_hint3__b8Z4n","hint4":"Hints_hint4__9ltGn","pulse":"Hints_pulse__R+ehw"};